import { Form, Spin } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { IModalitaPagamentoForm } from "core/interfaces/data/IModalitaPagamentoForm";
import ISceltaModalitaPagamentoProps from "components/SceltaModalitapagamento/ISceltaModalitaPagamentoProps";
import _ from "lodash";
import { useState } from "react";
import { FaRegCreditCard, FaPaypal, FaLandmark, FaGift } from "react-icons/fa";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { PaymentMode } from "types/PaymentMode";
import "./SceltaModalitaPagamento.css";
import { notifyValidationError } from "components/NotificaValidazioneFallita/NotificaValidazioneFallita";
import CustomButton from "components/CustomButton/CustomButton";
// import CustomRadioPayment from "components/CustomRadioPayment/CustomRadioPayment";
import HrText from "components/HrText/HrText";
import Label from "components/Label/Label";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";
import SingolaModalitaPagamento from "components/SceltaModalitapagamento/SingolaModalitaPagamento";

const SceltaModalitaPagamento: React.FC<ISceltaModalitaPagamentoProps> = ({
	OnSubmit,
	Back,
	BackButtonVisible,
	NuovaPrenotazione,
	NoteFieldVisible = false,
	dataForm,
	t,
}) => {
	const [form] = Form.useForm();
	const [spinning, setSpinning] = useState<boolean>(false);

	const [prestazioneGratuita] = useState<boolean>(dataForm.tariffa?.ImportoTariffaConIva === 0);
	const [itemSelected, setItemSelected] = useState<boolean>(prestazioneGratuita);

	const OnSubmitForm = async (data: IModalitaPagamentoForm) => {
		const submitData: IModalitaPagamentoForm = {
			note: data.note ?? "",
			pagamento: modalitaSelezionata!, //la modalita è necessaria a sbloccare il bottone submit, quindi dovrebbe essere valoraizzata
		};
		setSpinning(true);
		OnSubmit(submitData);
	};

	const OnFinishFailed = (e: any) => {
		const input = document.querySelector(`#${e.errorFields[0].name[0]}`);

		if (input) {
			input.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "start",
			});
		}

		const errors = e.errorFields;

		let notifica = {
			Title: t("modalitaPagamento.requiredMessages.notifica.titolo"),
			Message: new Array<string>(),
		};
		_.each(errors, (err, index: number) => {
			notifica.Message.push(t("modalitaPagamento.requiredMessages.notifica." + err.name[0]));
		});

		notifyValidationError(notifica.Title, notifica.Message);
	};

	const formItemSelected = () => {
		setItemSelected(true);
	};

	const [modalitaSelezionata, setModalitaSelezionata] = useState<PaymentMode | undefined>();

	const selezionaModalita = (modalita: PaymentMode) => {
		setModalitaSelezionata(modalita);
		setItemSelected(true);
	};

	return (
		<>
			<Spin spinning={spinning}>
				<Form id="formAssistito" onFinishFailed={OnFinishFailed} onFinish={OnSubmitForm} form={form} onChange={formItemSelected}>
					{NoteFieldVisible && (
						<>
							<HrText text={t("modalitaPagamento.note.title")} />

							<div>
								<Label text={t("modalitaPagamento.note.label")} />
								<Form.Item name="note">
									<TextArea size="large" inputMode="text" rows={3} />
								</Form.Item>
							</div>
							<br />
						</>
					)}
					<HrText text={t("modalitaPagamento.pagamento")} />
					<div className="lista-modalita-pagamento">
						{/* {!prestazioneGratuita && (
							<>
								{" "}
								<Label text={t("modalitaPagamento.form.tipo")} />
							</>
						)} 
						
						<Form.Item
							name="pagamento"
							rules={[{ required: true, message: t("modalitaPagamento.requiredMessages.notifica.pagamento") }]}
							className="input-pagamento-container"
							initialValue={prestazioneGratuita ? PaymentMode.SaltaPagamento : undefined}
						>
							<Radio.Group>
								<Space direction="vertical">
									{prestazioneGratuita ? (
										<CustomRadioPayment text={t("modalitaPagamento.form.pagamento.gratuita")} value={PaymentMode.SaltaPagamento} ico={<FaGift />} />
									) : (
										<>
											{window.CONFIG.REACT_APP_PAYMENT.STRIPE_PAYMENT_ENABLED && (
												<CustomRadioPayment
													text={t("modalitaPagamento.form.pagamento.carta")}
													value={PaymentMode.CartaDiCredito}
													ico={<FaRegCreditCard />}
												/>
											)}

											{window.CONFIG.REACT_APP_PAYMENT.PAYPAL_PAYMENT_ENABLED && (
												<CustomRadioPayment text={t("modalitaPagamento.form.pagamento.paypal")} value={PaymentMode.PayPal} ico={<FaPaypal />} />
											)}
											{window.CONFIG.REACT_APP_PAYMENT.BANK_TRANSFER_PAYMENT_ENABLED && (
												<CustomRadioPayment text={t("modalitaPagamento.form.pagamento.bonifico")} value={PaymentMode.Bonifico} ico={<FaLandmark />} />
											)}
										</>
									)}
								</Space>
							</Radio.Group>
						</Form.Item> */}

						{prestazioneGratuita ? (
							<SingolaModalitaPagamento
								selected={modalitaSelezionata === PaymentMode.SaltaPagamento}
								onClick={() => {
									selezionaModalita(PaymentMode.SaltaPagamento);
								}}
								text={t("modalitaPagamento.form.pagamento.gratuita")}
								value={PaymentMode.SaltaPagamento}
								ico={<FaGift className="icona-modalita-pagamento" />}
							/>
						) : (
							<>
								<p>{t("modalitaPagamento.form.tipo")}</p>
								{window.CONFIG.REACT_APP_PAYMENT.STRIPE_PAYMENT_ENABLED && (
									<SingolaModalitaPagamento
										key={PaymentMode.CartaDiCredito}
										selected={modalitaSelezionata === PaymentMode.CartaDiCredito}
										onClick={() => {
											selezionaModalita(PaymentMode.CartaDiCredito);
										}}
										text={t("modalitaPagamento.form.pagamento.carta")}
										value={PaymentMode.CartaDiCredito}
										ico={<FaRegCreditCard className="icona-modalita-pagamento" />}
									/>
								)}

								{window.CONFIG.REACT_APP_PAYMENT.PAYPAL_PAYMENT_ENABLED && (
									<SingolaModalitaPagamento
										key={PaymentMode.PayPal}
										selected={modalitaSelezionata === PaymentMode.PayPal}
										onClick={() => {
											selezionaModalita(PaymentMode.PayPal);
										}}
										text={t("modalitaPagamento.form.pagamento.paypal")}
										value={PaymentMode.PayPal}
										ico={<FaPaypal className="icona-modalita-pagamento" />}
									/>
								)}
								{window.CONFIG.REACT_APP_PAYMENT.BANK_TRANSFER_PAYMENT_ENABLED && (
									<SingolaModalitaPagamento
										key={PaymentMode.Bonifico}
										selected={modalitaSelezionata === PaymentMode.Bonifico}
										onClick={() => {
											selezionaModalita(PaymentMode.Bonifico);
										}}
										text={t("modalitaPagamento.form.pagamento.bonifico")}
										value={PaymentMode.Bonifico}
										ico={<FaLandmark className="icona-modalita-pagamento" />}
									/>
								)}
							</>
						)}
					</div>
					<div className="footer">
						{NuovaPrenotazione && (
							<span>
								<CustomTranslation t={t} type="condizioniVendita" i18Key={"riepilogo.text.confermaText"} />
							</span>
						)}
					</div>
					<br />
					<div className={"modalita-pagamento-button-box"}>
						{BackButtonVisible && <CustomButton text={t("backButton")} OnClick={Back} buttonType={CustomButtonType.negative} />}
						<CustomButton text={t("modalitaPagamento.conferma")} htmlType="submit" buttonType={CustomButtonType.positive} enabled={itemSelected} />
					</div>
				</Form>
			</Spin>
		</>
	);
};

export default Enhanced(SceltaModalitaPagamento, { componentNamespace: "SceltaModalitaPagamento" });
